import React, { Component } from "react"
import axios from "axios"
import settings from "settings"
import { Formik, Field, Form } from "formik"
import closingFields from "models/closing"
import DateField from "components/DateField"
import fieldStatus from "helpers/fieldStatus"
import NumberField from "components/NumberField"
import * as Yup from "yup"
import submitData from "helpers/asyncSubmitDataWithFiles"
import _ from "lodash"
import ReactSelect from "components/ReactSelect"
import Typeahead from "components/Typeahead"

class ClosingModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: closingFields,
			data: {
				address: "",
			},
			files: {
				hud_doc: [],
			},
		}
	}

	componentDidMount() {
		let data = this.props.data
		if (this.props.data.super) {
			data = _.last(this.props.data.sales)
			data.sale_id = data.id
		}
		let userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/getSale", data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((resp) => {
				this.setState({
					data: resp.data,
					fields: resp.data,
				})
			})
	}

	validation = () => {
		if (this.props.super) {
			let closing_date = Yup.number().required("Required").typeError("Please enter a value.")
			/* if(_.has(this, `props.data.sales`)) {
				let lastSale = _.last(this.props.data.sales)
				closing_date = Yup.number()
					.required("Required")
					.typeError("Please enter a value.")
					.moreThan(lastSale.sale_date, "Closing date must be after the sale date.")
			} */

			return Yup.object().shape({
				closing_price: Yup.number()
					.moreThan(10000, "Price must be more than $10,000")
					.lessThan(20000000, "Price must be less than $20,000,000")
					.typeError("Please enter a price.")
					.required("Required"),
				closing_date,
				realtor_involved: Yup.number().required("Required"),
			})
		} else {
			let shape = {
				closing_price: Yup.number()
					.moreThan(100000, "Price must be more than $100,000")
					.lessThan(10000000, "Price must be less than $10,000,000")
					.typeError("Please enter a price.")
					.required("Required"),
				closing_date: Yup.number()
					.required("Required")
					.typeError("Please enter a value.")
					.moreThan(this.props.data.sale_date, "Closing date must be after the sale date."),
				realtor_involved: Yup.number().required("Required"),
			}
			if (
				settings?.enabled?.salesRepUploadHUD &&
				settings.enabled.salesRepUploadHUD.includes(this.props.data.property)
			) {
				shape.hud_doc = Yup.mixed().required("File is required")
			}
			if (
				settings?.disabled?.realtorRequirement &&
				settings?.disabled?.realtorRequirement.includes(this.props.data.property)
			) {
			} else {
				shape.realtor_office = Yup.mixed().when("realtor_involved", {
					is: 1,
					then: Yup.number("Type in license number to choose a realtor from the list.")
						.positive("Type in license number to choose a realtor from the list.")
						.typeError("Please enter a value.")
						.required("Type in license number to choose a realtor from the list."),
					otherwise: Yup.string().nullable().notRequired(),
				})
				shape.realtor = Yup.mixed().when("realtor_involved", {
					is: 1,
					then: Yup.number("Type in license number to choose a realtor from the list.")
						.positive("Type in license number to choose a realtor from the list.")
						.typeError("Please enter a value.")
						.required("Type in license number to choose a realtor from the list."),
					otherwise: Yup.string().nullable().notRequired(),
				})
			}
			return Yup.object().shape(shape)
		}
	}

	hudDocument = (f) => {
		if (
			settings?.enabled?.salesRepUploadHUD &&
			settings.enabled.salesRepUploadHUD.includes(this.props.data.property)
		) {
			return (
				<li className={fieldStatus("hud_doc", f)}>
					<label htmlFor="hud_doc">
						HUD Doc <sup>*</sup>
					</label>
					{f.errors.hud_doc && f.touched.hud_doc && <div className="form__message">{f.errors.hud_doc}</div>}
					<input
						name="hud_doc"
						type="file"
						id="hud_doc"
						//className="noBorder fileHideText"
						onChange={(event) => {
							f.setFieldValue("hud_doc", event.currentTarget.files[0])
						}}
					/>
				</li>
			)
		}
		return ""
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	realtorFields = (f) => {
		if (f.values.realtor_involved == 1) {
			let realtorRequirement = true
			if (
				settings?.disabled?.realtorRequirement &&
				settings?.disabled?.realtorRequirement.includes(this.props.data.property)
			) {
				realtorRequirement = false
			}
			return (
				<React.Fragment>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor License Number{realtorRequirement ? <sup>*</sup> : ""}
						</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<Typeahead
							name="realtor"
							className="form__input"
							value={f.values.realtor}
							placeholder={f.values.realtor}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor}
							error={f.errors.realtor}
							reversed={true}
							ep="/typeaheadTrec"
						/>
					</li>
					<li className={fieldStatus("realtor_office", f)}>
						<label htmlFor="realtor_office">
							Brokerage License Number {realtorRequirement ? <sup>*</sup> : ""}
						</label>
						{f.errors.realtor_office && f.touched.realtor_office && (
							<div className="form__message">{f.errors.realtor_office}</div>
						)}
						<Typeahead
							name="realtor_office"
							className="form__input"
							value={f.values.realtor_office}
							placeholder={f.values.realtor_office}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor_office}
							error={f.errors.realtor_office}
							reversed={true}
							ep="/typeaheadTrec"
							callback={this.brokerageCallback}
						/>
					</li>
				</React.Fragment>
			)
		}
	}

	render() {
		let co
		if (this.state.data.co_first) {
			co = ` & ${this.state.data.co_first} ${this.state.data.co_last}`
		}
		return (
			<div className="modal">
				<h3>
					Add Closing: {this.props.data.address} | {this.state.data.buyer_first} {this.state.data.buyer_last}
					{co}
				</h3>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					validateOnMount={true}
					enableReinitialize
					onSubmit={async (values) => {
						// On the super side with adding this
						const formData = new FormData()
						if (this.props.data.super) {
							values.sale_id = this.props.data.lot.sale_id
						} else {
							// On the salesperson side
							values.sale_id = this.props.data.sale_id
						}
						for (let k in values) {
							formData.append(k, values[k])
						}
						let resp = await submitData("inputClosing", formData)
						console.log(resp)
						this.props.notify(resp, this.props.name)
					}}
					render={(f) => (
						<div>
							{/* console.log(f) */}
							<Form>
								<ul className="modalForm__list">
									<li className={fieldStatus("closing_date", f)}>
										<label htmlFor="closing_date">
											Closing Date<sup>*</sup>
										</label>
										{f.errors.closing_date && f.touched.closing_date && (
											<div className="form__message">{f.errors.closing_date}</div>
										)}
										<DateField
											name="closing_date"
											className="form__textarea"
											value={f.values.closing_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.closing_date}
											error={f.errors.closing_date}
											blockFuture={true}
										/>
									</li>
									<li className={fieldStatus("closing_price", f)}>
										<label htmlFor="closing_price">
											Closing Price <sup>*</sup>
										</label>
										{f.errors.closing_price && f.touched.closing_price && (
											<div className="form__message">{f.errors.closing_price}</div>
										)}
										<NumberField
											name="closing_price"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.closing_price}
											error={f.errors.closing_price}
											value={f.values.closing_price}
											thousandSeparator={true}
											prefix="$"
											//numeric={true}
										/>
									</li>
									<li className={fieldStatus("realtor_involved", f)}>
										<label htmlFor="realtor_involved">
											Realtor Involved? <sup>*</sup>
										</label>
										{f.errors.realtor_involved && f.touched.realtor_involved && (
											<div className="form__message">{f.errors.realtor_involved}</div>
										)}
										<ReactSelect
											name={`realtor_involved`}
											options={[
												{
													value: 0,
													label: "No",
												},
												{
													value: 1,
													label: "Yes",
												},
											]}
											value={f.values.realtor_involved}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									{this.realtorFields(f)}
									{this.hudDocument(f)}
								</ul>
								<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
							</Form>
						</div>
					)}
				/>
			</div>
		)
	}
}

export default ClosingModal
